import React from "react";
import {useTranslation} from "react-i18next";

export enum StatIconType {
    BEST_SCORE,
    MEAN,
    GAMES_PLAYED,
    WORDS_TYPED,
    ACCURACY,
    WORDS_PER_MINUTE,
    BEST_SCORE_SECONDS,
    MEAN_RANKING,
    MEAN_SECONDS,
    TIME_ELAPSED,
}

type StatDetailsIconType = {
    icon: StatIconType,
    data: number | string,
}

export const StatDetailsIcon: React.FC<StatDetailsIconType> = (props) => {
    const {t} = useTranslation();
    
    function getStats() {
        
        let textKey;
        switch (props.icon) {
            case StatIconType.WORDS_PER_MINUTE:
            case StatIconType.MEAN:
            case StatIconType.BEST_SCORE:
                textKey = "stats.x-words-per-minute"
                break;
                
            case StatIconType.GAMES_PLAYED:
                textKey = "stats.x-games"
                break;

            case StatIconType.WORDS_TYPED:
                textKey = "stats.x-words"
                break;
                
            case StatIconType.ACCURACY:
                textKey = "stats.x-accuracy"
                break;

            case StatIconType.TIME_ELAPSED:
            case StatIconType.MEAN_SECONDS:
            case StatIconType.BEST_SCORE_SECONDS:
                textKey = "game.x-time"
                break;

            case StatIconType.MEAN_RANKING:
                textKey = "stats.x-rank"
                break;
        }
        
        // @ts-ignore
        return t(textKey, {count: props.data});
    }
    
    function getStatName() {
        switch (props.icon) {
            case StatIconType.BEST_SCORE_SECONDS:
            case StatIconType.BEST_SCORE:
                return t("stats.best-score");

            case StatIconType.MEAN_SECONDS:
            case StatIconType.MEAN:
                return t("stats.mean");
                
            case StatIconType.GAMES_PLAYED:
                return t("stats.games-played");
                
            case StatIconType.WORDS_TYPED:
                return t("stats.words-typed");
                
            case StatIconType.ACCURACY:
                return t("stats.accuracy");

            case StatIconType.WORDS_PER_MINUTE:
                return t("stats.score");

            case StatIconType.MEAN_RANKING:
                return t("stats.mean-ranking");

            case StatIconType.TIME_ELAPSED:
                return t("stats.for-20-words");
        }
    }
    
    function getIcon() {
        switch (props.icon) {
            case StatIconType.BEST_SCORE_SECONDS:
            case StatIconType.BEST_SCORE:
                return "trophy";

            case StatIconType.MEAN_SECONDS:
            case StatIconType.MEAN:
                return "graph";
                
            case StatIconType.GAMES_PLAYED:
                return "refresh-arrow";
                
            case StatIconType.WORDS_TYPED:
                return "input";
                
            case StatIconType.ACCURACY:
                return "target";

            case StatIconType.WORDS_PER_MINUTE:
                return "speed";

            case StatIconType.MEAN_RANKING:
                return "ranking";

            case StatIconType.TIME_ELAPSED:
                return "stop-watch";
        }
    }

    return (
        <div className="flex flex-col items-center w-32 md:w-36 xl:w-40 gap-1">
            <img
                className="h-8 xl:h-11"
                src={`/icons/${getIcon()}.svg`}
                alt=""
            />

            <p className="text-xl text-center text-nowrap">{getStats()}</p>
            <p className="text-text-transparent text-nowrap">{getStatName()}</p>
        </div>
    )
}
